import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// NOUVEAU : On importe le fichier de questions IA que l'on vient de créer
import questionsIA from './questionsIA';

function Audit() {
  const navigate = useNavigate();

  // Variables d'état
  const [questions, setQuestions] = useState([]);
  const [reponses, setReponses] = useState({});
  const [scoreFinal, setScoreFinal] = useState(null);
  const [uploadStatus, setUploadStatus] = useState({});
  const [chargement, setChargement] = useState(true);

  // Récupération de l'URL API depuis le fichier .env
  const API_URL = process.env.REACT_APP_API_URL;

  // 1. LE VERROU DE SÉCURITÉ
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      navigate('/login');
    }
  }, [navigate]);

  // 2. L'AIGUILLAGE INTELLIGENT (Chargement des questions)
  useEffect(() => {
    // On regarde quel plan le client a choisi
    const planChoisi = localStorage.getItem('planChoisi') || '';
    
    // Si le nom du plan contient 'IA', 'Deepfake' ou 'Diagnostic Légal'
    const isAiAudit = planChoisi.includes('IA') || planChoisi.includes('Deepfake') || planChoisi.includes('Diagnostic Légal');

    if (isAiAudit) {
      console.log("Mode IA détecté - Chargement des questions locales");
      
      // ✂️ DÉCOUPAGE DES QUESTIONS SELON LE FORFAIT
      let limiteQuestions = 10; // Test de Choc (Gratuit) par défaut
      
      if (planChoisi.includes('Diagnostic')) {
        limiteQuestions = 40;
      } else if (planChoisi.includes('360')) {
        limiteQuestions = 90;
      } else if (planChoisi.includes('SOC IA')) {
        limiteQuestions = 120; // L'intégralité des questions
      }

      setQuestions(questionsIA.slice(0, limiteQuestions));
      setChargement(false);
    } else {
      // ➡️ Cas 2 : Audit Cyber classique (depuis le serveur)
      const limite = localStorage.getItem('limiteQuestions') || 14;
      fetch(`${API_URL}/questions?limit=${limite}`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data)) {
            setQuestions(data);
          } else {
            console.error("Erreur renvoyée par le serveur :", data);
            setQuestions([]); 
          }
          setChargement(false);
        })
        .catch(err => {
          console.error("Erreur réseau :", err);
          setQuestions([]);
          setChargement(false);
        });
    }
  }, [API_URL]);

  // 3. FONCTIONS DE GESTION DE L'AUDIT
  const choisirReponse = (id, val) => {
    setReponses(prev => ({ ...prev, [id]: val }));
  };

  // GESTION DE L'UPLOAD SUR RENDER
  const handleFileUpload = (e, qId) => {
    const file = e.target.files[0];
    if (!file) return;
    
    const fd = new FormData();
    fd.append('file', file);
    fd.append('question_id', qId);

    fetch(`${API_URL}/upload`, { 
      method: 'POST', 
      body: fd 
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setUploadStatus(prev => ({ ...prev, [qId]: data.filename }));
        } else {
          alert("Erreur lors de l'envoi : " + data.error);
        }
      })
      .catch(err => {
        console.error("Erreur d'upload :", err);
        alert("Impossible de joindre le serveur pour l'upload.");
      });
  };

  // SAUVEGARDE DU SCORE SUR NEON (Via Render)
  const calculerLeScore = () => {
    if (questions.length === 0) return; 
    
    const total = Object.values(reponses).reduce((a, b) => a + b, 0);
    const res = Math.round((total / (questions.length * 2)) * 100);
    setScoreFinal(res);
    
    const userString = localStorage.getItem('user');
    let userId = null;
    if (userString) {
      const userObj = JSON.parse(userString);
      userId = userObj.id;
    }

    fetch(`${API_URL}/save-score`, { 
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify({ 
        score: res,
        user_id: userId,     
        reponses: reponses   
      }) 
    })
    .then(response => response.json())
    .then(data => {
      console.log("Audit sauvegardé avec succès !", data);
    })
    .catch(err => console.error("Erreur sauvegarde :", err));
  };

  // GÉNÉRATION DU PDF PAR IA (Sur Render)
  const telechargerPDF = async () => {
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = storedUser.id;

    if (!userId) {
      alert("Veuillez vous connecter.");
      navigate('/login');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/generate-pdf`, { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ 
          score: scoreFinal, 
          reponses: reponses,
          entreprise: storedUser.company || "VOTRE ORGANISATION",
          user_id: userId 
        }) 
      });

      if (response.status === 403) {
        const errorData = await response.json();
        alert(errorData.message); 
        navigate('/pricing');
        return;
      }

      if (!response.ok) throw new Error("Erreur de génération du PDF");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = "Rapport_Audit_Cyber_IA.pdf";
      a.click();
    } catch (err) {
      console.error("Erreur PDF :", err);
      alert("Erreur lors de la création du rapport PDF.");
    }
  };

  const prog = questions.length > 0 ? Math.round((Object.keys(reponses).length / questions.length) * 100) : 0;

  // VERIFICATION DU TYPE D'AUDIT POUR LE TITRE
  const isAiAuditTitle = localStorage.getItem('planChoisi')?.includes('IA') || localStorage.getItem('planChoisi')?.includes('Deepfake') || localStorage.getItem('planChoisi')?.includes('Diagnostic Légal');

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial' }}>
      
      <div style={{ position: 'sticky', top: '70px', background: 'white', padding: '10px 0', zIndex: 100 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <b>Progression</b><b style={{ color: isAiAuditTitle ? '#8b5cf6' : '#3498db' }}>{prog}%</b>
        </div>
        <div style={{ width: '100%', height: '10px', background: '#eee', borderRadius: '10px', overflow: 'hidden', marginTop: '5px' }}>
          <div style={{ width: `${prog}%`, height: '100%', background: isAiAuditTitle ? '#8b5cf6' : '#3498db', transition: 'width 0.3s ease' }}></div>
        </div>
      </div>

      <h1 style={{ textAlign: 'center', margin: '40px 0', color: isAiAuditTitle ? '#8b5cf6' : '#2c3e50' }}>
        {isAiAuditTitle ? 'Audit AI Act & Deepfake' : 'Audit Cyber & Conformité'}
      </h1>

      {chargement ? (
        <p style={{ textAlign: 'center', color: '#7f8c8d', fontStyle: 'italic' }}>⏳ Initialisation de l'audit...</p>
      ) : questions.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', background: '#f8d7da', color: '#721c24', borderRadius: '8px', border: '1px solid #f5c6cb' }}>
            🚨 <b>Erreur de chargement.</b><br/> 
            Impossible de récupérer les questions.
        </div>
      ) : (
        <p style={{ textAlign: 'center', color: '#7f8c8d' }}>Votre audit contient <b>{questions.length} questions</b> stratégiques.</p>
      )}

      {scoreFinal !== null && (
        <div style={{ textAlign: 'center', background: '#f9f9f9', padding: '30px', borderRadius: '15px', border: `2px solid ${isAiAuditTitle ? '#8b5cf6' : '#2c3e50'}`, marginBottom: '30px' }}>
          <h2 style={{ fontSize: '48px', color: '#27ae60', margin: 0 }}>{scoreFinal}%</h2>
          <button onClick={telechargerPDF} style={{ marginTop: '20px', padding: '10px 20px', background: isAiAuditTitle ? '#8b5cf6' : '#3498db', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer' }}>📄 Télécharger PDF</button>
        </div>
      )}

      {!chargement && questions.map((q, index) => (
        <div key={q.id} style={{ background: '#fff', border: '1px solid #eee', padding: '20px', borderRadius: '12px', margin: '20px 0', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
          <p style={{ fontSize: '16px' }}>
            <span style={{ color: '#bdc3c7', fontWeight: 'bold', marginRight: '10px' }}>#{index + 1}</span>
            <b style={{ color: isAiAuditTitle ? '#8b5cf6' : '#3498db' }}>[{q.module || q.category}]</b> {q.text}
          </p>
          <div style={{ display: 'flex', gap: '10px', margin: '15px 0' }}>
            <button onClick={() => choisirReponse(q.id, 2)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #ccc', background: reponses[q.id] === 2 ? '#2ecc71' : '#fff', color: reponses[q.id] === 2 ? '#fff' : '#333', cursor: 'pointer', fontWeight: reponses[q.id] === 2 ? 'bold' : 'normal' }}>Oui</button>
            <button onClick={() => choisirReponse(q.id, 1)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #ccc', background: reponses[q.id] === 1 ? '#f1c40f' : '#fff', color: reponses[q.id] === 1 ? '#fff' : '#333', cursor: 'pointer', fontWeight: reponses[q.id] === 1 ? 'bold' : 'normal' }}>Partiel</button>
            <button onClick={() => choisirReponse(q.id, 0)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #ccc', background: reponses[q.id] === 0 ? '#e74c3c' : '#fff', color: reponses[q.id] === 0 ? '#fff' : '#333', cursor: 'pointer', fontWeight: reponses[q.id] === 0 ? 'bold' : 'normal' }}>Non</button>
          </div>
          
          <div 
            style={{ border: '2px dashed #ccc', padding: '10px', borderRadius: '10px', textAlign: 'center' }}
          >
            <label style={{ cursor: 'pointer' }}>
              <span style={{ color: '#7f8c8d', fontSize: '14px' }}>
                {uploadStatus[q.id] ? `✅ Preuve ajoutée : ${uploadStatus[q.id]}` : "📁 Cliquez pour ajouter une preuve (optionnel)"}
              </span>
              <input type="file" style={{ display: 'none' }} onChange={(e) => handleFileUpload(e, q.id)} />
            </label>
          </div>
        </div>
      ))}

      {!chargement && questions.length > 0 && (
        <button onClick={calculerLeScore} disabled={Object.keys(reponses).length < questions.length} style={{ width: '100%', padding: '20px', background: Object.keys(reponses).length < questions.length ? '#ccc' : (isAiAuditTitle ? '#8b5cf6' : '#2c3e50'), color: 'white', border: 'none', borderRadius: '10px', fontSize: '18px', fontWeight: 'bold', cursor: Object.keys(reponses).length < questions.length ? 'not-allowed' : 'pointer', marginTop: '30px' }}>
          {Object.keys(reponses).length < questions.length ? `Répondez encore à ${questions.length - Object.keys(reponses).length} question(s)` : "✅ Valider mon Audit"}
        </button>
      )}
    </div>
  );
}

export default Audit;